import { InjectableClass } from '@fino/lib-injection';

export class FormFieldsService extends InjectableClass {
  constructor($timeout, $q) {
    'ngInject';
    super({$timeout, $q});

    this.callbacks = {
      validators: {},
      fieldResetters: {},
      randomDataFillers: {},
      devModeToggles: {}
    };
  }

  getFormKey(form) {
    return form.$$parent ? form.$$parent.name : form.$name;
  }

  initForForm(form) {
    const formKey = this.getFormKey(form);
    Object.keys(this.callbacks).forEach(k => {
      if (!this.callbacks[k][formKey]) {
        this.callbacks[k][formKey] = [];
      }
    });
  }

  register(form, callbacks) {
    const formKey = this.getFormKey(form);
    this.initForForm(form);
    let unregister = {};
    Object.keys(this.callbacks).forEach(k => {
      if (callbacks[k] && angular.isFunction(callbacks[k])) {
        this.callbacks[k][formKey].push(callbacks[k]);
        unregister[k] = callbacks[k];
      }
    });
    return () => {
      Object.keys(unregister).forEach(k => {
        let index = this.callbacks[k][formKey].indexOf(unregister[k]);
        this.callbacks[k][formKey].splice(index, 1);
      });
    };
  }

  toggleDevMode(form, options) {
    const formKey = this.getFormKey(form);
    let cbs = this.callbacks.devModeToggles[formKey];
    if (cbs && cbs.length) {
      cbs.forEach(cb => cb(options));
    }
  }

  fillRandomData(form, options) {
    const formKey = this.getFormKey(form);
    let cbs = this.callbacks.randomDataFillers[formKey];
    if (cbs && cbs.length) {
      cbs.forEach(cb => cb(options));
    }
  }

  resetFields(form) {
    const formKey = this.getFormKey(form);
    let cbs = this.callbacks.fieldResetters[formKey];
    if (cbs && cbs.length) {
      cbs.forEach(cb => cb());
    }
  }

  validate(form) {
    const formKey = this.getFormKey(form);
    const { $timeout, $q } = this;
    let defer = $q.defer();

    // mark form as submitted
    form.$submitted = true;

    // Call registered validators
    let cbs = this.callbacks.validators[formKey];
    if (cbs && cbs.length) {
      cbs.forEach(cb => cb());
    }

    $timeout(() => {
      if (form.$valid) {
        defer.resolve();
      }
      else {
        defer.reject();
      }
    });

    return defer.promise;
  }
}
